/**
 * Le champ email d'un patient peut porter plusieurs adresses — deux parents séparés
 * reçoivent chacun la même facture. Elles s'écrivent séparées par des virgules ou des
 * points-virgules ; le serveur les range sous la forme `a@x.fr, b@y.fr`.
 */
export const MAX_EMAIL_RECIPIENTS = 5;
/** Assez pour attraper une faute de frappe, sans prétendre juger ce que le SMTP acceptera. */
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
/** « a@x.fr ; b@y.fr, » → ['a@x.fr', 'b@y.fr'] : découpe, sans rien valider. */
export function parseEmails(raw) {
    return (raw ?? '')
        .split(/[,;]/)
        .map((part) => part.trim())
        .filter((part) => part !== '');
}
export function isValidEmail(address) {
    return EMAIL_PATTERN.test(address);
}
/** La forme rangée en base et affichée : virgule et espace. */
export function formatEmails(addresses) {
    return addresses.join(', ');
}
//# sourceMappingURL=emails.js.map